import React from 'react';
import { ReactComponent as Transfer } from 'images/transfer.svg';
import { ReactComponent as BlueTransfer } from 'images/blue-transfer-icon.svg';
import { ReactComponent as Profile } from 'images/profile.svg';
import { ReactComponent as Secure } from 'images/lock.svg';
import { ReactComponent as PlaidIdentityIcon } from 'images/plaid-identity.svg';
import { ReactComponent as MoneyIcon } from 'images/yellow-money-icon.svg';

export interface DescriptionItem {
  description: string | null;
  missedPaymentDescription: string | null;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  missedPaymentIcon: React.FC<React.SVGProps<SVGSVGElement>> | null;
}

export const descriptionItems: DescriptionItem[] = [
  {
    description: 'Retrieves your account and routing number for depositing your funds and making payments.',
    missedPaymentDescription: 'Make your loan payment with one click. No typos or long numbers to enter.',
    icon: Transfer,
    missedPaymentIcon: PlaidIdentityIcon,
  },
  {
    description: 'Verifies your identity and income.',
    missedPaymentDescription: 'Ensure there are funds in the account to avoid overdraft fees.',
    icon: Profile,
    missedPaymentIcon: MoneyIcon,
  },
  {
    description: null,
    missedPaymentDescription: 'Cancel authorization anytime.',
    icon: BlueTransfer,
    missedPaymentIcon: null,
  },
  {
    description: 'Uses bank level security protocols.',
    missedPaymentDescription: 'Uses bank level security protocols.',
    icon: Secure,
    missedPaymentIcon: null,
  },
];

export const aiCoachDescriptionItems: DescriptionItem[] = [
  {
    description: 'Track your income and expense',
    missedPaymentDescription: null,
    missedPaymentIcon: null,
    icon: Transfer,
  },
  {
    description: 'Automate your savings',
    missedPaymentDescription: null,
    missedPaymentIcon: null,
    icon: Profile,
  },
  {
    description: 'Uses bank level security protocols',
    missedPaymentDescription: null,
    missedPaymentIcon: null,
    icon: Secure,
  },
];

export const incomeVerificationDescriptionItems: DescriptionItem[] = [
  {
    description: 'Confirms your income through bank transactions.',
    missedPaymentDescription: null,
    icon: Profile,
    missedPaymentIcon: null,
  },
  {
    description: 'Uses bank level security protocols.',
    missedPaymentDescription: null,
    icon: Secure,
    missedPaymentIcon: null,
  },
];
